import { render, staticRenderFns } from "./lianjieIndex.vue?vue&type=template&id=a6346a9c&scoped=true&"
import script from "./lianjieIndex.vue?vue&type=script&lang=js&"
export * from "./lianjieIndex.vue?vue&type=script&lang=js&"
import style0 from "./lianjieIndex.vue?vue&type=style&index=0&id=a6346a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6346a9c",
  null
  
)

export default component.exports